import { defaultsConfig } from "~config/sport/defaults";
import { tennisUi } from "~config/sport/tennisUi.ts";
import { CompetitorTypes } from "~enums/competitorTypes";
import { PeriodTypes } from "~enums/periodTypes.ts";
import type { SportConfiguration } from "~types/sportConfiguration";

export const tennisConfig: SportConfiguration = {
  ...defaultsConfig,
  competitorType: CompetitorTypes.Person,
  maxParticipantCount: 2,
  uiConfiguration: tennisUi,
  periods: {
    [PeriodTypes.Period1]: { intlKey: "period.set1" },
    [PeriodTypes.Period2]: { intlKey: "period.set2" },
    [PeriodTypes.Period3]: { intlKey: "period.set3" },
    [PeriodTypes.Period4]: { intlKey: "period.set4" },
    [PeriodTypes.Period5]: { intlKey: "period.set5" },
    [PeriodTypes.Period6]: { intlKey: "period.set6" },
    [PeriodTypes.Period7]: { intlKey: "period.set7" },
  },
};
